import { fetchComputedInventoryForModification } from 'models/kiosks/helpers';

import { kioskInventoryRouteStore } from '../domain/store';

export default (fieldName, sortingOrder) => {
  return fetchComputedInventoryForModification()
  .then(() => kioskInventoryRouteStore.setSortingColumn(fieldName, sortingOrder));
};
